import React from 'react';
import { useFormContext } from 'react-hook-form';
import {
  TextInput,
  EmailInput,
  SubmitButton,
  TextInputBold
} from '../../form-elements';
import FORM_CONFIG, { getFormFieldRules } from '../formConfig';


const StepOne = ({ nextStep, hasPersonalInfoErrors }) => {
  const { 
    register, 
    formState: { errors } 
  } = useFormContext();

  return (
    <section 
      id={FORM_CONFIG.sections.personalInfo.id} 
      aria-label="Personal Information"
    >
      <div className="bg-white py-12 px-6 lg:p-14 rounded-all_48">
        <h2 className="text-p_medium lg:text-h4_medium text-dark_green lg:mb-12 mb-8 text-center" id={FORM_CONFIG.sections.personalInfo.id}>
          {FORM_CONFIG.sections.personalInfo.title}
        </h2>
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6" role="group" aria-labelledby={FORM_CONFIG.sections.personalInfo.id}> 
          <TextInput 
            label="First Name*" 
            {...register('firstName', getFormFieldRules('firstName'))} 
            aria-required="true" 
            error={errors.firstName?.message} 
            id="firstName"
            placeholder="First Name*"
          />
          <TextInputBold 
            label="Middle Name" 
            {...register('middleName', getFormFieldRules('middleName'))} 
            aria-required="false" 
            error={errors.middleName?.message} 
            id="middleName"
            placeholder="Middle Name"
            additionalText="(Optional)"
          />
          <TextInput 
            label="Last Name*" 
            {...register('lastName', getFormFieldRules('lastName'))} 
            aria-required="true" 
            error={errors.lastName?.message} 
            id="lastName"
            placeholder="Last Name*"
          />
        </div>
      
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6" role="group" aria-labelledby={FORM_CONFIG.sections.personalInfo.id}> 
          <EmailInput 
            label="Email Address*" 
            {...register('email', getFormFieldRules('email'))} 
            aria-required="true" 
            error={errors.email?.message} 
            id="email"
            placeholder="Email Address*"
          />
          <TextInput 
            label="NPI*" 
            {...register('npiNumber', getFormFieldRules('npiNumber'))} 
            aria-required="true" 
            error={errors.npiNumber?.message}
            id="npiNumber"
            placeholder="NPI*"
          />
        </div>

        <div className="grid grid-cols-1 gap-6 mt-12">
          <span className="text-p_footnote text-black/70">*Required field</span>
          {hasPersonalInfoErrors && (
            <span id={FORM_CONFIG.sections.personalInfo.errorId} className="text-p text-error">
              *Please fill all the required fields
            </span>
          )}
        </div>
      </div>
      
      <div className="flex flex-col gap-6 justify-center items-center mt-12">
        <SubmitButton type="button" onClick={nextStep} aria-label="Proceed to next step">
          Next
        </SubmitButton>
        <p className="lg:text-p text-[14px] leading-[18px] text-white text-center font-regular lg:w-full w-[297px]"> Need to update your information or opt out of the Surgeon Selector? <a href="/connect" className="text-white underline font-bold">Connect with a rep</a> to make changes.</p>
      </div>
    </section>
  );
};

export default StepOne; 
